<template>
  <div>
    <Header>Student List</Header>
    <div class="tiled-bar-image"></div>  
    <Main>
      <div class="mt-3 text-left p-3 bg-gray-100 rounded-md !shadow">
        <AdvancedSearchForm
          v-model="filters"
          :searchInput="searchInput"
          @filtersUpdated="onFiltersUpdated"
        />
        <!-- {{ filters }} -->
        <div class="flex gap-4 flex-wrap">
          <Input
            ref="dateInput"
            class="rounded-md shadow-sm"
            type="date"
            v-model="query.date"
            @input="onSelectDate"
          />
          <Sort
            v-for="(sort, index) in sorts"
            :key="index"
            :name="sort.name"
            :selectedSort="selectedSort"
            @setSelectedSort="selectedSort = $event"
          >
            {{ sort.text }}
          </Sort>
        </div>
      </div>
      <div class="flex relative justify-center items-center mt-4">
        <Pagination :pages="pages" to="/StudentList" />
        <div class="absolute right-0 text-gray-400 mt-1 text-sm">
          Total Students: {{ totalStudents }}
        </div>
      </div>
      <Spinner
        v-if="displayLoadingStudentsSpinner"
        message="Loading Students"
        :size="16"
      />
      <div class="mt-6 space-y-2 pb-6">
        <StudentItem
          v-for="(item, index) in students"
          :key="index"
          :item="item"
          :selected="item.dbId == selected"
          :showOperationsInfoDisplay="user.can('view_internal_cst_data')"
          :showPartitionName="displayPartitions"
          :caller="$options.name"
          @changeSelected="selected = $event"
          :existsPendingRequests="item.existsPendingRequests" 
        />
      </div>
      <div class="flex justify-center pb-4" v-if="students.length > 0">
        <Pagination :pages="pages" to="/StudentList" />
      </div>
    </Main>
    <div class="fixed bottom-3 left-3 group space-y-2">
      <div
        class="space-y-2"
        :class="{
          hidden: !actionsOpen
        }"
      >
        <button
          type="button"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300"
          @click="$router.push({ name: 'NewRequestForm' })"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4v16m8-8H4"
              />
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              Add student
            </div>
          </div>
        </button>
        <button
          type="button"
          :disabled="selected == -1"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="changeRequestAction"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
              />
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
             <div class="text-base text-gray-600 uppercase font-bold">
              New change request
            </div>
          </div>
        </button>
        <button
          v-if="showOneTimeNoRide()"
          :disabled="selected == -1"
          type="button"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="noRideAction"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              One Time No ride
            </div>
          </div>
        </button>
        <Modal size="md">
          <template #button="slotProps">
            <button
              type="button"
              :disabled="selected == -1"
              class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
              @click="() => slotProps.openModal()"
            >
              <div
                class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-7 w-7 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <div
                class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
              >
                <div class="text-base text-gray-600 uppercase font-bold">
                  Cancel Transportation
                </div>
              </div>
            </button>
          </template>
          <template #title>Transportation Cancellation</template>
          <template #content="slotProps">
            <CancelForm
              @closeModal="() => slotProps.closeModal(false)"
              :studentInfo="selectedStudentData"
            />
          </template>
        </Modal>
        <button
          v-if="showOneTimeRide()"
          :disabled="selected == -1 || !selectedStudentData || !selectedStudentData.dbId"
          type="button"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="oneTimeRideAction">
          <div class="rounded-full bg-white h-12 w-12 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <text
                x="50%"
                y="50%"
                text-anchor="middle"
                dominant-baseline="central"
                font-size="15"
                fill="currentColor"
                font-weight="normal">
                1x
              </text>
            </svg>
          </div>
          <div class="justify-center items-center px-3 flex-grow hidden group-hover:flex">
            <div class="text-base text-gray-600 uppercase font-bold">
              One Time Ride
            </div>
          </div>
        </button>
        <button
          type="button"
          :disabled="selected == -1"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="studentHistoryAction"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              class="h-7 w-7 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 21 21"
            >
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                transform="translate(3 2)"
              >
                <path
                  d="m14.5 12.5v-7l-5-5h-5c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2z"
                />
                <path d="m8.5 4.5v4h3" />
                <path
                  d="m2.5 2.5c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2"
                />
              </g>
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              Student Details
            </div>
          </div>
        </button>
        <Modal
          size="full"
          width="max">
          <template #button="slotProps">
            <button
              v-if="showNotes()"
              :disabled="selected == -1"
              type="button"
              class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
              @click="() => slotProps.openModal()"
            >
              <div
                class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-7 w-7 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </div>
              <div
                class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
              >
                <div class="text-base text-gray-600 uppercase font-bold">
                  Notes
                </div>
              </div>
            </button>
          </template>
          <template #title
            >Notes for
            {{
              `${selectedStudentData.firstName} ${selectedStudentData.lastName}`
            }}</template
          >
          <template #content>
            <NoteForm :studentInfo="selectedStudentData" />
          </template>
        </Modal>
      </div>
      <button
        type="button"
        class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300"
        @click="actionsOpen = !actionsOpen"
      >
        <div
          class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
        >
          <svg
            v-if="!actionsOpen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-7 w-7 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <svg
            v-if="actionsOpen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-7 w-7 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
            />
          </svg>
        </div>
        <div
          class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
        >
          <div class="text-base text-gray-600 uppercase font-bold">
            {{ `${actionsOpen ? 'Hide' : 'Show'} actions` }}
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Main from '../components/Main.vue'
import Input from '../components/Input.vue'
import Header from '../components/Header.vue'
import StudentItem from '../components/items/StudentItem.vue'
import Modal from '../components/Modal.vue'
import CancelForm from './CancelForm.vue'
import Sort from '../components/Sort.vue'
import NoteForm from '../components/forms/NoteForm.vue'
import Pagination from '../components/Pagination.vue'
import AdvancedSearchForm from '../components/Search/AdvancedSearchForm.vue'
import Spinner from '../components/Spinner.vue'

import settings from '../services/settings.js'
import studentListService from '../services/pages/studentList.js'

import user from '../services/user/user.js'
import view from '../services/user/view.js'
import time from '../services/utils/time.js'
import events from '../services/events.js'
import { forOwn, omit, isEqual } from 'lodash'
import fastDeepEquals from 'fast-deep-equal'

import DROPDOWN_LISTS from '../components/DropdownLists.json'

export default {
  name: 'StudentList',
  components: {
    Main,
    Input,
    Header,
    StudentItem,
    Modal,
    CancelForm,
    Sort,
    NoteForm,
    Pagination,
    AdvancedSearchForm,
    Spinner,
  },
  data() {
    return {
      user: undefined,
      view: undefined,

      query: {
        search: '',
        date: undefined,
      },
      searchInput: undefined,
      pages: {},
      numPerPage: 25,
      students: [],
      totalStudents: 0,
      displayPartitions: false,
      displayLoadingStudentsSpinner: false,
      schoolYear: undefined,
      selected: -1,
      filters: [],
      selectedStudentData: {},
      actionsOpen: true,
      selectedSort: {
        name: '',
        descending: false
      },
      sorts: [
        {
          name: 'studentId',
          text: 'Student ID'
        },
        {
          name: 'firstName',
          text: 'First Name'
        },
        {
          name: 'lastName',
          text: 'Last Name'
        },
        {
          name: 'building',
          text: 'Building'
        }
      ]
    }
  },
  eventCallbackIds: {},
  methods: {
    async setStudentsData() {
      this.view = await view.get()

      this.numPerPage = studentListService.getNumPerPage()
      this.schoolYear = this.view.getSchoolYear()

      let apiParams = {
        date: this.query.date,
        page: this.query.page,
        search: this.query.search,
        perPage: this.numPerPage,
        sortBy: this.selectedSort.name
          ? (this.selectedSort.descending ? '-' : '') + this.selectedSort.name
          : '',
      }

      let studentsData
      try {
        this.displayLoadingStudentsSpinner = true
        studentsData = (await studentListService.getStudentDataFromServer(apiParams)).data
        this.displayLoadingStudentsSpinner = false
      }
      catch {
        this.displayLoadingStudentsSpinner = false
      }

      this.pages = studentsData.pages
      this.students = studentsData.content
      this.totalStudents = studentsData.page_data.num_students

      this.displayPartitions = this.checkDisplayPartitions()
      this.selectedStudentData = this.getSelectedStudentData()
      if (this.selectedStudentData === undefined) {
        this.selected = -1
      }
    },
    setQuerySearch(search) {
      if (Object.hasOwn(this.$route.query, 'search')) {
        this.query.search = search
      }
      else {
        delete this.query.search
      }
    },
    setQueryDate(date) {
      if (Object.hasOwn(this.$route.query, 'date')) {
        this.query.date = date
      }
      else {
        delete this.query.date
      }
    },
    setQueryPage(page) {
      if (Object.hasOwn(this.$route.query, 'page')) {
        this.query.page = page
      }
      else {
        delete this.query.page
      }
    },
    updateQueryParams(queryObj) {
      if (!fastDeepEquals(queryObj, this.$route.query)) {
        this.$router.push({
          query: queryObj
        })
        return true
      }
      else {
        return false
      }
    },
    onSelectDate() {
      this.setFiltersQuery()
    },
    setFiltersQuery() {
      let queryObj = {
        query: {
          ...this.$route.query
        }
      }
      if (this.query.search) {
        queryObj.query.search = this.query.search
      }
      else {
        delete queryObj.query.search
      }

      if (this.query.date) {
        if (queryObj.query.date || this.query.date !== time.today()) {
          queryObj.query.date = this.query.date
        }
        else {
          delete queryObj.query.date
        }
      }
      else {
        delete queryObj.query.date
      }

      this.updateQueryParams(queryObj.query)
    },
    setSearchQueryFromQueryParams() {
      forOwn(this.$route.query, (value, key) => {
        switch (key) {
          case 'search':
            this.searchInput = value
            this.setQuerySearch(value)
            break
          case 'date':
            this.setQueryDate(value)
            break
          case 'page':
            this.setQueryPage(value)
            break
          case 'sortByName':
            this.selectedSort.name = value
            break
          case 'sortByDescending':
            this.selectedSort.descending = value === 'true'
            break
          case 'filters':
            try {
              this.filters = JSON.parse(value)
            } catch {
              this.filters = []
            }
            break
        }
      })
      if (!Object.hasOwn(this.$route.query, 'search')) {
        delete this.query.search
      }
      if (!Object.hasOwn(this.$route.query, 'date')) {
        this.query.date = time.today()
      }
    },
    onFiltersUpdated() {
      if (this.filters.length === 0) {
        delete this.query.search
      }
      else if (this.filters.length === 1) {
        if (!this.filters[0].keyword) {
          delete this.query.search
        }
        else if (this.filters[0].field) {
          this.query.search = JSON.stringify({
            keyword: this.filters[0].keyword,
            field: this.filters[0].field
          })
        }
        else {
          this.query.search = this.filters[0].keyword
        }
      }
      else if (this.filters.length > 1) {
        this.query.search = JSON.stringify(this.filters)
      }
      this.setFiltersQuery()
    },
    getSelectedStudentData() {
      return this.students.find(item => item.dbId === this.selected)
    },
    noRideAction() {
      const { dbId, internalId, studentId, firstName, lastName } = this.selectedStudentData
      this.$router.push({
        name: 'OneTimeNoRide',
        params: {
          student: {
            dbId: dbId,
            internalId: internalId,
            studentId: studentId,
            firstName: firstName,
            lastName: lastName
          }
        }
      })
    },
    showNotes() {
      return this.user?.can('view_student_notes')
    },
    showInternalId() {
      return this.user?.can('view_internal_cst_data')
    },
    showOneTimeNoRide() {
      return this.user?.can('submit_one_time_no_ride')
    },
    showOneTimeRide() {
      return this.user?.can('submit_one_time_ride')
    },
    changeRequestAction() {
      settings.requestForm.dbId = this.selectedStudentData.dbId
      this.$router.push({
        name: 'ChangeRequestForm'
      })
    },
    oneTimeRideAction() {
      if (!this.selectedStudentData?.dbId) {
        return
      }

      this.$router.push(
        `/OneTimeRide/${this.selectedStudentData.dbId}`
      )
    },
    studentHistoryAction() {
      if (this.selected < 0) {
        return
      }

      this.$router.push({
        name: 'StudentHistory',
        params: {
          studentDbId: this.selectedStudentData.dbId
        }
      })
    },
    checkDisplayPartitions() {
      if (this.user === undefined) {
        return false
      }

      return this.view.hasMultiple('partition')
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_student_list')) {
        if (this.user.can('view_vendor_forms')) {
          this.$router.push({
            name: 'VendorForms'
          })
        }
        else {
          this.$router.push({
            path: '/'
          })
        }
        return true
      }
    },
    updateUserPartition(partitionId) {
      events.trigger('partitionUpdate', partitionId)
    }
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    if (this.user.can('view_internal_cst_data')) {
      this.sorts.unshift({
        name: 'internalId',
        text: 'Internal ID'
      })
    }

    this.$options.eventCallbackIds.listPageSettingsUpdate = events.register(
      'listPageSettingsUpdate',
      (currNumPerPage, schoolYear) => {
        if (this.numPerPage != currNumPerPage || this.schoolYear != schoolYear) {
          this.setStudentsData()
        }
      }
    )
    this.$options.eventCallbackIds.viewUpdated = events.register('viewUpdated', async () => {
      this.setStudentsData()
    })

    this.setSearchQueryFromQueryParams()
    this.setStudentsData()
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    events.remove('listPageSettingsUpdate', this.$options.eventCallbackIds.listPageSettingsUpdate)
    events.remove('viewUpdated', this.$options.eventCallbackIds.viewUpdated)
  },
  computed: {
    schoolYearDisplay() {
      if (this.schoolYear) {
        return DROPDOWN_LISTS.schoolYears[this.schoolYear]
      } else {
        return ''
      }
    }
  },
  watch: {
    '$route.query': function () {
      this.setSearchQueryFromQueryParams()
      this.setStudentsData()
    },
    selected: function () {
      this.selectedStudentData = this.getSelectedStudentData()
    },
    selectedSort: {
      handler() {
        let query = omit(this.$route.query, ['sortByName', 'sortByDescending'])
        if (this.selectedSort.name) {
          query.sortByName = this.selectedSort.name
          query.sortByDescending = this.selectedSort.descending
        }
        const queryCompare = {
          ...query,
          sortByDescending: query.sortByDescending ? 'true' : 'false'
        }
        if (!isEqual(this.$route.query, queryCompare)) {
          this.$router.replace({
            query: query
          })
        }
      },
      deep: true
    },
  }
}
</script>
